import script from "./FichaMedica.vue?vue&type=script&setup=true&lang=js"
export * from "./FichaMedica.vue?vue&type=script&setup=true&lang=js"

import "./FichaMedica.vue?vue&type=style&index=0&id=68c84703&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c84703"]])

export default __exports__